import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Nav from "../Nav";
import "../ProjectTemplate.css";

export default function BlankProject() {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem("theme");
    return saved || "dark";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  return (
    <div className="app">
      <Nav theme={theme} setTheme={setTheme} />
      <div className="project-wrap">
        <Link to="/" className="project-back">&larr; Back to home</Link>

        <div className="project-hero-card">
          <h1>Blank Project</h1>
          <p className="project-subtitle">Lorem ipsum dolor sit amet.</p>
          <p className="project-blurb">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </div>

        <div className="project-section">
          <div className="project-card-full">
            <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 10px" }}>Summary</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
          </div>
        </div>

        <Link to="/" className="project-back" style={{ marginTop: 40 }}>&larr; Back to home</Link>
      </div>

      <footer className="project-footer">
        <p>&copy; {new Date().getFullYear()} Nameless</p>
        <a href="#" onClick={(e) => e.preventDefault()}>email@example.com</a>
      </footer>
    </div>
  );
}
